<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Edycja numeru listu przewozowego
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="currentComplaintReturnNumber.packageNumber"
                                label="Numer listu przewozowego"
                                :error-messages="packageNumberErrors"
                                required
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Potwierdź"
                    @click="savePackageNumber()"
                >
                    Potwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { findIndex } from 'lodash'

export default {
    name: 'ComplaintReturnEditDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        complaintReturnNumber: {
            type: Object,
            default: null
        },
        currentComplaint: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            complaint: {},
            currentComplaintReturnNumber: {},
            packageNumber: null,
        }
    },
    validations: {
        currentComplaintReturnNumber: {
            packageNumber: {
                required
            }
        }
    },
    computed: {
        packageNumberErrors() {
            const errors = []

            if (!this.$v.currentComplaintReturnNumber.packageNumber.$dirty) return errors
            !this.$v.currentComplaintReturnNumber.packageNumber.required && errors.push('Proszę podać numer listu przewozowego.')

            return errors
        },
    },
    watch: {
        isOpen() {
            this.currentComplaintReturnNumber = JSON.parse(JSON.stringify(this.complaintReturnNumber))
            this.complaint = JSON.parse(JSON.stringify(this.currentComplaint))

        },
    },
    methods: {
        savePackageNumber() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }
            const index = findIndex(this.complaint.complaintReturnNumber, { 'id': this.currentComplaintReturnNumber.id })

            this.complaint.complaintReturnNumber.splice(index, 1, this.currentComplaintReturnNumber)
            this.$emit('on-confirm', this.complaint)
            this.onClose()
        },
        onClose() {
            setTimeout(() => {
                this.complaint = {},
                this.currentComplaintReturnNumber = {},
                this.packageNumber = null
            }, 500)
            this.$v.$reset()
            this.$emit('on-close')
        },
    }
}
</script>

